// For more information: https://github.com/desandro/masonry

import Masonry from 'masonry-layout';
const loaded = [];

const initMasonry = async () => {
    const elements = document.querySelectorAll('[data-masonry]');
    if (! elements.length) {
        return;
    }

    const {default: Masonry} = await import ('masonry-layout');

    // Instantiation
    elements.forEach((element) => {
        // Prevent multiple executions
        if (loaded.includes(element)) {
            return;
        }

        const masonryElem = new Masonry(element, {
            horizontalOrder: false,
            percentPosition: false
        });

        if (! element.id) {
            element.id = 'masonry-container-' + Date.now() + '-' + Math.trunc(Math.random() * 100);
        }

        loaded[element.id] = masonryElem;

    });

    document.addEventListener('MasonryReload', () => {
        reload();
    });
}

const reload = async (containerId) => {
    let count = 0;
    // Reload several time to keep masonry Ok
    const reloadMasonryInterval = setInterval(() => {
        if (count > 10) {
            clearInterval(reloadMasonryInterval);
        }
        if (containerId) {
            reloadContainer(containerId);
        } else {
            for (const masonryContainerId in loaded) {
                reloadContainer(masonryContainerId);
            }
        }
        count++;
    }, 300);
}

const reloadContainer = async (masonryContainerId) => {
    loaded[masonryContainerId] = new Masonry(
        document.querySelector('#' + masonryContainerId),
        {
            horizontalOrder: false,
            percentPosition: false
        }
    );
}

export default class MasonryGrid {

    static init() {
        initMasonry();
    }

    static initReload() {
        reload()
    }
}
